import { useMemo } from 'react';
import { useFeatureVisibility } from '@/contexts/FeatureVisibilityContext';
import {
  getVisibleProductCatFilters,
  PRODUCT_CAT_FILTER_FIELDS,
  type ProductCatFilterField,
} from '@/utils/productCatFilters';

export function useVisibleProductCatFilters(): ProductCatFilterField[] {
  const { config } = useFeatureVisibility();
  return useMemo(() => getVisibleProductCatFilters(config), [config]);
}

export function useHasVisibleProductCatFilters(): boolean {
  const visible = useVisibleProductCatFilters();
  return visible.length > 0;
}

export { PRODUCT_CAT_FILTER_FIELDS };
